import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CustomMaterialModule} from './_shared/config/custom-material/custom-material.module';
import {environment} from '../environments/environment';
import {AngularFireModule} from 'angularfire2';
import {AngularFireAuthModule} from 'angularfire2/auth';
import {AngularFirestoreModule} from 'angularfire2/firestore';
import {FlexLayoutModule} from '@angular/flex-layout';
import {RestApiRegisterService} from './_shared/services/rest-api/register.service';
import {HttpModule} from '@angular/http';
import {RestApiAuthService} from './_shared/services/rest-api/auth.service';
import {FirebaseAuthenticationService} from './_shared/services/firebase/authentication.service';
import {FirebaseUserService} from './_shared/services/firebase/user.service';
import {AuthStateGuard} from './_shared/guards/authState.guard';
import {OrganizationStateGuard} from './_shared/guards/organizationState.guard';
import {GlobalPropertyService} from './_shared/services/local/global-property.service';
import {FirebasePropertyService} from './_shared/services/firebase/property.service';
import {FirebaseRepairService} from './_shared/services/firebase/repair.service';
import {FirebaseStorageService} from './_shared/services/firebase/firebase-storage.service';
import {TenantStateGuard} from './_shared/guards/tenantState.guard';
import {FirebaseNotesService} from './_shared/services/firebase/notes.service';
import {FirebaseSettingsService} from './_shared/services/firebase/settings.service';
import {StripePaymentService} from './_shared/services/other/stripe-payment.service';
import {FirebaseTenantService} from './_shared/services/firebase/tenant.service';
import {FirebaseLandlordService} from './_shared/services/firebase/landlord.service';


import 'hammerjs';
import {RestApiUserService} from './_shared/services/rest-api/updateUser.service';
import {RestApiOrganizationService} from './_shared/services/rest-api/organization.service';
import {RestApiPropertyService} from './_shared/services/rest-api/property.service';
import {RestApiMarketingService} from './_shared/services/rest-api/marketing.service';
import {SendgridApiService} from './_shared/services/other/sendgrid.service';
import {FirebaseDocumentService} from './_shared/services/firebase/document.service';
import {FirebaseRentService} from './_shared/services/firebase/rent.service';
import {GlobalActionButtonService} from './_shared/services/local/global-actionButton.service';



/**
 *  Global Services
 */
const APP_SERVICES = [
  FirebaseAuthenticationService,
  FirebaseDocumentService,
  FirebasePropertyService,
  FirebaseLandlordService,
  FirebaseNotesService,
  FirebaseRepairService,
  FirebaseRentService,
  FirebaseSettingsService,
  FirebaseStorageService,
  FirebaseTenantService,
  FirebaseUserService,
  GlobalPropertyService,
  GlobalActionButtonService,
  RestApiRegisterService,
  RestApiAuthService,
  RestApiOrganizationService,
  RestApiPropertyService,
  RestApiUserService,
  RestApiMarketingService,
  SendgridApiService,
  StripePaymentService
];


const APP_GUARDS = [
  AuthStateGuard,
  OrganizationStateGuard,
  TenantStateGuard
];


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebase), // imports firebase/app needed for everything
    AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features
    BrowserAnimationsModule,
    AppRoutingModule,
    CustomMaterialModule, // imports Material2 modules
    FlexLayoutModule,
    HttpModule
  ],
  providers: [APP_SERVICES, APP_GUARDS],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/app.module.ts